import Swiper, {EffectFade} from "swiper";

Swiper.use([EffectFade])
export function initAboutSlider(){


    let swiper = new Swiper('#about_slider', {
        loop: false,
        speed: 500,
        preloadImages: false,
        slidesPerView: 1,
        spaceBetween: 0,
        noSwiping: true,
        allowTouchMove: false,
        autoHeight: true,
        watchOverflow: true,
        resizeObserver: true,
        wrapperHeight: 'auto',
        breakpoints: {
            0: {
                loop: false,
                slidesPerView: 1,
                spaceBetween: 0
            },
            500: {
                slidesPerView: 1,
                spaceBetween: 0
            },
            768: {
                slidesPerView: 1,
                spaceBetween: 0
            }
        }
    });

    return swiper;
}